var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Dimmer, Form, Input, Loader, Message } from "semantic-ui-react";
import FieldWithErrorDisplay from "../FieldWithErrorDisplay";
import { postJsonWithAuthn } from "../RequestHelpers";
var UpdateDiscountsModal = /** @class */ (function (_super) {
    __extends(UpdateDiscountsModal, _super);
    function UpdateDiscountsModal(props) {
        var _this = _super.call(this, props) || this;
        _this.onV3RnaFishProbeSetCatalogChange = function (_, data) {
            var str = data.value;
            _this.setState({ v3RnaFishProbeSetCatalog: str });
        };
        _this.onV3RnaFishProbeSetCustomChange = function (_, data) {
            var str = data.value;
            _this.setState({ v3RnaFishProbeSetCustom: str });
        };
        _this.onV3ManualAmplifierChange = function (_, data) {
            var str = data.value;
            _this.setState({ v3ManualAmplifier: str });
        };
        _this.onV3RnaFishBuffersChange = function (_, data) {
            var str = data.value;
            _this.setState({ v3RnaFishBuffers: str });
        };
        _this.onV3SecondaryIfProbeChange = function (_, data) {
            var str = data.value;
            _this.setState({ v3SecondaryIfProbe: str });
        };
        _this.onV3SecondaryIfBuffersChange = function (_, data) {
            var str = data.value;
            _this.setState({ v3SecondaryIfBuffers: str });
        };
        _this.onAutomatedProProbeSetCatalogChange = function (_, data) {
            var str = data.value;
            _this.setState({ automatedProProbeSetCatalog: str });
        };
        _this.onAutomatedProProbeSetCustomChange = function (_, data) {
            var str = data.value;
            _this.setState({ automatedProProbeSetCustom: str });
        };
        _this.onAutomatedProDetectChange = function (_, data) {
            var str = data.value;
            _this.setState({ automatedProDetect: str });
        };
        _this.onGoldRnaFishProbeSetCatalogChange = function (_, data) {
            var str = data.value;
            _this.setState({ goldRnaFishProbeSetCatalog: str });
        };
        _this.onGoldRnaFishProbeSetCustomChange = function (_, data) {
            var str = data.value;
            _this.setState({ goldRnaFishProbeSetCustom: str });
        };
        _this.onGoldManualAmplifierChange = function (_, data) {
            var str = data.value;
            _this.setState({ goldManualAmplifier: str });
        };
        _this.onGoldRnaFishBuffersChange = function (_, data) {
            var str = data.value;
            _this.setState({ goldRnaFishBuffers: str });
        };
        _this.onGoldSecondaryIfProbeChange = function (_, data) {
            var str = data.value;
            _this.setState({ goldSecondaryIfProbe: str });
        };
        _this.onGoldSecondaryIfBuffersChange = function (_, data) {
            var str = data.value;
            _this.setState({ goldSecondaryIfBuffers: str });
        };
        _this.onManualProDetectChange = function (_, data) {
            var str = data.value;
            _this.setState({ manualProDetect: str });
        };
        _this.onManualGoldIfEncoderChange = function (_, data) {
            var str = data.value;
            _this.setState({ manualGoldIfEncoder: str });
        };
        _this.onAutomatedGoldIfEncoderChange = function (_, data) {
            var str = data.value;
            _this.setState({ automatedGoldIfEncoder: str });
        };
        _this.onAutomatedGoldIfDetectChange = function (_, data) {
            var str = data.value;
            _this.setState({ automatedGoldIfDetect: str });
        };
        _this.submit = function () {
            _this.setState({
                loading: true,
            }, function () {
                postJsonWithAuthn("/admin/users/id/" + encodeURIComponent(_this.props.userId) + "/discounts", JSON.stringify({
                    discounts: {
                        v3RnaFishProbeSetCatalog: _this.state.v3RnaFishProbeSetCatalog,
                        v3RnaFishProbeSetCustom: _this.state.v3RnaFishProbeSetCustom,
                        v3ManualAmplifier: _this.state.v3ManualAmplifier,
                        v3RnaFishBuffers: _this.state.v3RnaFishBuffers,
                        v3SecondaryIfProbe: _this.state.v3SecondaryIfProbe,
                        v3SecondaryIfBuffers: _this.state.v3SecondaryIfBuffers,
                        automatedProProbeSetCatalog: _this.state.automatedProProbeSetCatalog,
                        automatedProProbeSetCustom: _this.state.automatedProProbeSetCustom,
                        automatedProDetect: _this.state.automatedProDetect,
                        goldRnaFishProbeSetCatalog: _this.state.goldRnaFishProbeSetCatalog,
                        goldRnaFishProbeSetCustom: _this.state.goldRnaFishProbeSetCustom,
                        goldManualAmplifier: _this.state.goldManualAmplifier,
                        goldRnaFishBuffers: _this.state.goldRnaFishBuffers,
                        goldSecondaryIfProbe: _this.state.goldSecondaryIfProbe,
                        goldSecondaryIfBuffers: _this.state.goldSecondaryIfBuffers,
                        manualProDetect: _this.state.manualProDetect,
                        manualGoldIfEncoder: _this.state.manualGoldIfEncoder,
                        automatedGoldIfEncoder: _this.state.automatedGoldIfEncoder,
                        automatedGoldIfDetect: _this.state.automatedGoldIfDetect
                    }
                })).then(function (resp) {
                    if (resp.ok) {
                        _this.setState({
                            loading: false,
                            success: true,
                            errors: []
                        });
                        return;
                    }
                    else {
                        return resp.json();
                    }
                }).then(function (resp) {
                    if (resp !== undefined) {
                        _this.setState({
                            loading: false,
                            success: false,
                            errors: resp.errors
                        });
                    }
                    else {
                        _this.setState({
                            loading: false,
                            success: true,
                            errors: []
                        });
                    }
                }).catch(function (rej) {
                    console.error("Couldn't submit comment: " + rej);
                });
            });
        };
        _this.state = {
            loading: false,
            success: false,
            errors: [],
            v3RnaFishProbeSetCatalog: props.initialValues.v3RnaFishProbeSetCatalog,
            v3RnaFishProbeSetCustom: props.initialValues.v3RnaFishProbeSetCustom,
            v3ManualAmplifier: props.initialValues.v3ManualAmplifier,
            v3RnaFishBuffers: props.initialValues.v3RnaFishBuffers,
            v3SecondaryIfProbe: props.initialValues.v3SecondaryIfProbe,
            v3SecondaryIfBuffers: props.initialValues.v3SecondaryIfBuffers,
            automatedProProbeSetCatalog: props.initialValues.automatedProProbeSetCatalog,
            automatedProProbeSetCustom: props.initialValues.automatedProProbeSetCustom,
            automatedProDetect: props.initialValues.automatedProDetect,
            goldRnaFishProbeSetCatalog: props.initialValues.goldRnaFishProbeSetCatalog,
            goldRnaFishProbeSetCustom: props.initialValues.goldRnaFishProbeSetCustom,
            goldManualAmplifier: props.initialValues.goldManualAmplifier,
            goldRnaFishBuffers: props.initialValues.goldRnaFishBuffers,
            goldSecondaryIfProbe: props.initialValues.goldSecondaryIfProbe,
            goldSecondaryIfBuffers: props.initialValues.goldSecondaryIfBuffers,
            manualProDetect: props.initialValues.manualProDetect,
            manualGoldIfEncoder: _this.props.initialValues.manualGoldIfEncoder,
            automatedGoldIfEncoder: props.initialValues.automatedGoldIfEncoder,
            automatedGoldIfDetect: props.initialValues.automatedGoldIfDetect
        };
        return _this;
    }
    UpdateDiscountsModal.prototype.render = function () {
        return React.createElement(Dimmer.Dimmable, { as: Form, error: this.state.errors.length > 0 },
            React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                React.createElement(Loader, null)),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/discounts/v3RnaFishProbeSetCatalog', labelContent: "RNA-FISH (v3.0) Probe - catalog" },
                React.createElement(Input, { placeholder: 'No discount', onChange: this.onV3RnaFishProbeSetCatalogChange, value: this.state.v3RnaFishProbeSetCatalog })),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/discounts/v3RnaFishProbeSetCustom', labelContent: "RNA-FISH (v3.0) Probe - custom" },
                React.createElement(Input, { placeholder: 'No discount', onChange: this.onV3RnaFishProbeSetCustomChange, value: this.state.v3RnaFishProbeSetCustom })),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/discounts/v3ManualAmplifier', labelContent: "RNA-FISH / 2ºIHC (v3.0) Amplifier" },
                React.createElement(Input, { placeholder: 'No discount', onChange: this.onV3ManualAmplifierChange, value: this.state.v3ManualAmplifier })),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/discounts/v3RnaFishBuffers', labelContent: "RNA-FISH (v3.0) Buffers" },
                React.createElement(Input, { placeholder: 'No discount', onChange: this.onV3RnaFishBuffersChange, value: this.state.v3RnaFishBuffers })),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/discounts/v3SecondaryIfProbe', labelContent: "2ºIHC (v3.0) Probe" },
                React.createElement(Input, { placeholder: 'No discount', onChange: this.onV3SecondaryIfProbeChange, value: this.state.v3SecondaryIfProbe })),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/discounts/v3SecondaryIfBuffers', labelContent: "2ºIHC (v3.0) Buffers" },
                React.createElement(Input, { placeholder: 'No discount', onChange: this.onV3SecondaryIfBuffersChange, value: this.state.v3SecondaryIfBuffers })),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/discounts/automatedProProbeSetCatalog', labelContent: "RNA-ISH Probe - catalog" },
                React.createElement(Input, { placeholder: 'No discount', onChange: this.onAutomatedProProbeSetCatalogChange, value: this.state.automatedProProbeSetCatalog })),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/discounts/automatedProProbeSetCustom', labelContent: "RNA-ISH Probe - custom" },
                React.createElement(Input, { placeholder: 'No discount', onChange: this.onAutomatedProProbeSetCustomChange, value: this.state.automatedProProbeSetCustom })),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/discounts/automatedProDetect', labelContent: "RNA-ISH Detect" },
                React.createElement(Input, { placeholder: 'No discount', onChange: this.onAutomatedProDetectChange, value: this.state.automatedProDetect })),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/discounts/goldRnaFishProbeSetCatalog', labelContent: "Gold RNA-FISH Probe - catalog" },
                React.createElement(Input, { placeholder: 'No discount', onChange: this.onGoldRnaFishProbeSetCatalogChange, value: this.state.goldRnaFishProbeSetCatalog })),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/discounts/goldRnaFishProbeSetCustom', labelContent: "Gold RNA-FISH Probe - custom" },
                React.createElement(Input, { placeholder: 'No discount', onChange: this.onGoldRnaFishProbeSetCustomChange, value: this.state.goldRnaFishProbeSetCustom })),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/discounts/goldManualAmplifier', labelContent: "Gold RNA-FISH / 2ºIF Amplifier" },
                React.createElement(Input, { placeholder: 'No discount', onChange: this.onGoldManualAmplifierChange, value: this.state.goldManualAmplifier })),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/discounts/goldRnaFishBuffers', labelContent: "Gold RNA-FISH Buffers" },
                React.createElement(Input, { placeholder: 'No discount', onChange: this.onGoldRnaFishBuffersChange, value: this.state.goldRnaFishBuffers })),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/discounts/goldSecondaryIfProbe', labelContent: "Gold 2ºIF Probe" },
                React.createElement(Input, { placeholder: 'No discount', onChange: this.onGoldSecondaryIfProbeChange, value: this.state.goldSecondaryIfProbe })),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/discounts/goldSecondaryIfBuffers', labelContent: "Gold 2ºIF Buffers" },
                React.createElement(Input, { placeholder: 'No discount', onChange: this.onGoldSecondaryIfBuffersChange, value: this.state.goldSecondaryIfBuffers })),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/discounts/manualProDetect', labelContent: "Manual Pro Detect" },
                React.createElement(Input, { placeholder: 'No discount', onChange: this.onManualProDetectChange, value: this.state.manualProDetect })),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/discounts/manualGoldIfEncoder', labelContent: "Manual Gold IF Encoder" },
                React.createElement(Input, { placeholder: 'No discount', onChange: this.onManualGoldIfEncoderChange, value: this.state.manualGoldIfEncoder })),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/discounts/automatedGoldIfEncoder', labelContent: "Automated Gold IF - Encoder" },
                React.createElement(Input, { placeholder: 'No discount', onChange: this.onAutomatedGoldIfEncoderChange, value: this.state.automatedGoldIfEncoder })),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/discounts/automatedGoldIfDetect', labelContent: "Automated Gold IF - Detect" },
                React.createElement(Input, { placeholder: 'No discount', onChange: this.onAutomatedGoldIfDetectChange, value: this.state.automatedGoldIfDetect })),
            this.state.success &&
                React.createElement(Message, { positive: true }, "Discounts updated."),
            React.createElement(Button, { disabled: this.state.success, icon: 'save', label: 'Update discounts', labelPosition: 'left', onClick: this.submit, positive: true }));
    };
    return UpdateDiscountsModal;
}(React.PureComponent));
export default UpdateDiscountsModal;
;
//# sourceMappingURL=UpdateDiscountsModal.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/UpdateDiscountsModal.js
// module id = 1448
// module chunks = 0